import Link from 'next/link';
import {
  navIntegration,
  navCorporateDesign,
  navBasicElements,
  navComponents,
} from '@/lib/SideBarNavEntrys';
import { ActiveRoute } from '@/lib/helpers';

export const SideBarNav = () => {
  return (
    <nav className="sidebar">
      <a
        data-bs-toggle="collapse"
        href="#collapseIntegration"
        role="button"
        aria-expanded="true"
        aria-controls="collapseIntegration"
        className="h4"
      >
        Integration
      </a>
      <div className="collapse show" id="collapseIntegration">
        <ul className="nav flex-column mb-4">
          {navIntegration.map(([key, value]) => {
            return (
              <li className={`nav-item ${ActiveRoute(value.link)}`} key={key}>
                <Link href={value.link} legacyBehavior>
                  <a className={`nav-link p-1 m-0`} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <hr />
      <a
        data-bs-toggle="collapse"
        href="#collapseCorporateDesign"
        role="button"
        aria-expanded="true"
        aria-controls="collapseCorporateDesign"
        className="h4"
      >
        Corporate Design
      </a>
      <div className="collapse show" id="collapseCorporateDesign">
        <ul className="nav flex-column mb-4">
          {navCorporateDesign.map(([key, value]) => {
            return (
              <li className={`nav-item ${ActiveRoute(value.link)}`} key={key}>
                <Link href={value.link} legacyBehavior>
                  <a className={`nav-link p-1 m-0`} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <hr />
      <a
        data-bs-toggle="collapse"
        href="#collapseCorporate"
        role="button"
        aria-expanded="true"
        aria-controls="collapseCorporate"
        className="h4"
      >
        Basiselemente
      </a>
      <div className="collapse show" id="collapseCorporate">
        <ul className="nav flex-column mb-4">
          {navBasicElements.map(([key, value]) => {
            return (
              <li className={`nav-item ${ActiveRoute(value.link)}`} key={key}>
                <Link href={value.link} legacyBehavior>
                  <a className={`nav-link p-1 m-0`} title={value.title}>
                    {value.title}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>

      <hr />
      <a
        data-bs-toggle="collapse"
        href="#collapseComponents"
        role="button"
        aria-expanded="true"
        aria-controls="collapseComponents"
        className="h4"
      >
        Komponenten
      </a>
      <div className="collapse show" id="collapseComponents">
        <ul className="nav flex-column mb-4">
          {navComponents.map(([key, value]) => {
            return (
              <li className={`nav-item ${ActiveRoute(value.link)}`} key={key}>
                <Link href={value.link} legacyBehavior>
                  <a className="nav-link p-1 m-0" title={value.title}>
                    {value.title}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
      <hr />
    </nav>
  );
};
